import { css } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import { getColorStyle, getFontFamilyStyle } from './utils.styles';

export const getBodyFontOverride = (
  fontColor?: string | null,
  fontFamily?: string | null
): SerializedStyles | '' => {
  if (!(fontColor || fontFamily)) return '';
  const colorStyle = getColorStyle(fontColor);
  const familyStyle = getFontFamilyStyle(fontFamily);
  const fontStyle = `
    ${colorStyle} ${familyStyle}
  `;
  return css`
    #public-wrapper {
      .sticky-nav {
        .pages-nav-container .list-inline > li a {
          ${fontStyle}
        }
      }

      .faq-section {
        h2,
        h4,
        p {
          ${fontStyle}
        }
      }

      #rsvp-page-v2 {
        label,
        h2 {
          ${fontStyle}
        }
        /* select.form-control {
          ${fontStyle}
        } */
        a.events-actions__link-prev {
          ${fontStyle}
        }
        a {
          .toggle-details-button {
            ${fontStyle}
          }
          i {
            ${fontStyle}
            text-decoration-color: ${getColorStyle(fontColor)};
          }
        }
      }

      .section-title,
      .travel-name,
      .member-name,
      .event-name {
        ${fontStyle}
      }
      .poi-title {
        ${fontStyle}
        a {
          ${fontStyle}
        }
      }

      .wedding-date,
      .wedding-location,
      .hashtag,
      .location,
      .date,
      .month,
      .day,
      .year {
        ${fontStyle}
        h3 {
          // for wedding date on homepage
          ${fontStyle}
        }
      }

      #registry-page {
        a.page-description-cta {
          ${fontStyle}
        }
      }

      .radio-inline {
        ${fontStyle}
      }

      h4,
      address,
      p {
        ${fontStyle}
      }

      textarea {
        ${fontStyle}

        &::placeholder {
          ${fontStyle}
        }
      }

      #events-page, #travel-page, .public-page-passcode {
        i:not(.glyphicon) {
          ${colorStyle}
        }
      }

      // Exclude styles from registry page
      :not(#registry-zola a) {
        ${fontStyle}
      }
      :not(#registry-zola label) {
        ${fontStyle}
      }
      #registry-zola p {
        color: black !important;
      }
    }
  `;
};
